module.exports = __webpack_public_path__ + "static/media/pl-soft-commu.3c32ce62.png";